import shdbLogo from "@/assets/ShdbLogo.png";

type AuthFormHeaderProps = {
  title: string;
  instructions?: string;
};

export const AuthFormHeader = ({
  title,
  instructions,
}: AuthFormHeaderProps) => {
  return (
    <div>
      <img
        className="mx-auto h-12 w-auto"
        src={shdbLogo}
        alt="Shop Hero Logo"
      />
      <h2 className="mt-6 text-center text-3xl font-extrabold text-primary-foreground">
        {title}
      </h2>
      {instructions && (
        <p className="mt-4 text-center text-sm">{instructions}</p>
      )}
    </div>
  );
};
